module.exports = __webpack_public_path__ + "img/default_head_img@2x.00631130.png";